import Konva from "konva";
import { base64ToFile } from "@/modules/common";

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => resolve(loadImage(src));
    img.setAttribute("crossOrigin", "anonymous");
    img.src = src;
  });
}

export function exportImageBase64(
  stage: Konva.Stage,
  targetWidth: number,
  targetHeight: number
) {
  const exportStage = stage.clone({
    width: targetWidth,
    height: targetHeight,
  });
  const scaleX = targetWidth / stage.width();
  const scaleY = targetHeight / stage.height();
  exportStage.find("Transformer").forEach((item) => item.destroy());
  exportStage.find("Image").forEach((item) => {
    item.x(item.x() * scaleX);
    item.y(item.y() * scaleY);
    item.scaleX(item.scaleX() * scaleX);
    item.scaleY(item.scaleY() * scaleY);
  });
  exportStage.batchDraw();
  // return exportStage.toDataURL({ mimeType: "image/jpeg" })!;
  return exportStage.toDataURL({ mimeType: "image/png" })!;
}

export function exportImage(
  stage: Konva.Stage,
  targetWidth: number,
  targetHeight: number
) {
  return base64ToFile(
    exportImageBase64(stage, targetWidth, targetHeight),
    `${new Date().toLocaleString().replace(/\D/g, "")}.png`
  );
}

export async function addImageToStage(
  stage: Konva.Stage,
  layer: Konva.Layer,
  urlOrCanvas: string | HTMLCanvasElement | HTMLImageElement,
  params: {
    draggable?: boolean;
    fullScreen?: boolean;
    transform?: MediaTransform;
    mediaId?: number;
    mateTraitAnimationId?: number;
    id?: string;
    visible?: boolean;
  } = {
    draggable: true,
    fullScreen: false,
    visible: true,
  }
) {
  const {
    transform,
    mediaId,
    id,
    fullScreen,
    draggable,
    mateTraitAnimationId,
  } = params;
  const image =
    typeof urlOrCanvas === "string"
      ? await loadImage(urlOrCanvas)
      : urlOrCanvas;
  const scaleX = stage.width() / image.width;
  const scaleY = stage.height() / image.height;
  const scale = fullScreen
    ? Math.max(scaleX, scaleY)
    : Math.min(scaleX, scaleY);

  const imgNode = new Konva.Image({
    image,
    draggable,
    x: transform?.position?.x ?? stage.width() / 2,
    y: transform?.position?.y ?? stage.height() / 2,
    scale: transform?.scale ?? { x: scale, y: scale },
    width: transform?.width ?? undefined,
    height: transform?.height ?? undefined,
    // zIndex: transform?.zIndex,
    offset: {
      x: transform?.offset?.x ?? image.width / 2,
      y: transform?.offset?.y ?? image.height / 2,
    },
    visible: params.visible,
    mediaId,
    id,
    mateTraitAnimationId,
  });
  // 兼容Konva的Bug，当scaleX为负数（水平翻转）时，会旋转180度
  // 在这里用0进行重置
  // https://konvajs.org/docs/sandbox/Mirror_Canvas_Shape.html
  // 评论区：rotate 180 degree
  imgNode.rotation(transform?.rotate ?? 0);
  layer.add(imgNode);
  return { imgNode, scale };
}
